// Module
var code = "<section class=\"PartnerDisclaimers\"> <h1 class=\"PartnerDisclaimers__title\">{{::PartnerDisclaimers.title}}</h1> <p class=\"PartnerDisclaimers__subtitle\">{{::PartnerDisclaimers.subTitle}}</p> <p class=\"PartnerDisclaimers__body\">{{::PartnerDisclaimers.body}}</p> </section> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/legal/partnerDisclaimers/partnerDisclaimers.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;